var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "w-full flex justify-center pt-6 pb-24 lg:px-6 bg-slate-200"
    },
    [
      _c(
        "div",
        {
          staticClass:
            "w-full flex flex-col bg-pure-white border border-slate-400 rounded-3xl"
        },
        [
          _c(
            "div",
            {
              staticClass:
                "pt-10 pb-4 lg:px-10 px-4 flex items-center justify-between border-b border-slate-400"
            },
            [
              _c(
                "div",
                { staticClass: "flex items-center gap-2" },
                [
                  _c("BlTextTitle4", { attrs: { text: "Files" } }),
                  _vm._v(" "),
                  _c("BlBubbleCount", {
                    attrs: { count: _vm.totalClientDocuments || 0 }
                  })
                ],
                1
              ),
              _vm._v(" "),
              _c("input", {
                attrs: {
                  type: "file",
                  name: "upload_client_document",
                  id: "upload_client_document",
                  hidden: "",
                  multiple: ""
                },
                on: { change: _vm.onButtonUpload }
              }),
              _vm._v(" "),
              _c("BlInputButton", {
                attrs: { icon: "plus", label: "Upload files" },
                on: { clicked: _vm.openUploadDoc }
              })
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass:
                "lg:px-10 px-4 lg:pt-6 pt-4 pb-10 flex flex-col lg:gap-6 gap-4"
            },
            [
              _c("div", { staticClass: "flex items-center justify-between" }, [
                _c(
                  "div",
                  { staticClass: "flex items-center gap-2" },
                  [
                    _c("BlInputSearch", {
                      staticClass: "w-80",
                      attrs: { input: _vm.searchInput },
                      on: { changed: _vm.onInputSearch }
                    }),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "w-40" },
                      [
                        _c("BlInputFilter", {
                          attrs: { input: _vm.filterInput },
                          on: { changed: _vm.onChangeFilter }
                        })
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c("BlSort", {
                      staticClass: "w-60",
                      attrs: {
                        options: _vm.sortOptions,
                        defaultValue: _vm.defaultSort,
                        dropDirection: "left"
                      },
                      on: {
                        change: function($event) {
                          return _vm.onChangeSort($event)
                        }
                      },
                      model: {
                        value: _vm.sortInput,
                        callback: function($$v) {
                          _vm.sortInput = $$v
                        },
                        expression: "sortInput"
                      }
                    })
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    staticClass: "py-1 px-1 flex bg-slate-400",
                    style: { borderRadius: "8px", height: "2.375rem" }
                  },
                  _vm._l(_vm.modeOptions, function(opt) {
                    return _c(
                      "div",
                      {
                        key: opt.value,
                        staticClass:
                          "h-full w-30 flex items-center justify-center gap-1 flex-shrink-0 rounded cursor-pointer transition-all duration-300",
                        class:
                          _vm.mode === opt.value
                            ? "bg-pure-white"
                            : "bg-slate-400",
                        on: {
                          click: function($event) {
                            _vm.mode = opt.value
                          }
                        }
                      },
                      [
                        _c("BlIcon", {
                          staticClass: "w-4 h-4",
                          attrs: { icon: opt.icon, color: "slate-6" }
                        }),
                        _vm._v(" "),
                        _c("BlTextSubtitle3", { attrs: { text: opt.label } })
                      ],
                      1
                    )
                  }),
                  0
                )
              ]),
              _vm._v(" "),
              _vm.mode === "thumbnail"
                ? _c("div", [
                    _vm.fetchLoading
                      ? _c(
                          "div",
                          {
                            staticClass: "w-full h-120 grid place-items-center"
                          },
                          [_c("div", { staticClass: "blum-loader" })]
                        )
                      : !_vm.clientDocuments.length
                      ? _c(
                          "div",
                          {
                            staticClass:
                              "w-full h-120 text-center flex flex-col items-center justify-center gap-2 rounded border-2 border-dashed border-slate-500",
                            class: { "bg-slate-200": _vm.dropActive },
                            on: {
                              dragenter: function($event) {
                                $event.preventDefault()
                                _vm.dropActive = true
                              },
                              dragover: function($event) {
                                $event.preventDefault()
                                _vm.dropActive = true
                              },
                              dragleave: function($event) {
                                $event.preventDefault()
                                _vm.dropActive = false
                              },
                              drop: function($event) {
                                $event.preventDefault()
                                return _vm.onDropUpload($event)
                              }
                            }
                          },
                          [
                            _c(
                              "div",
                              {
                                staticClass:
                                  "h-10 w-10 flex items-center justify-center flex-shrink-0 bg-light-purple-100 rounded-full"
                              },
                              [
                                _c("BlIcon", {
                                  staticClass: "h-6 w-6",
                                  style: { rotate: "180deg" },
                                  attrs: { icon: "download" }
                                })
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c(
                              "div",
                              { staticClass: "flex items-center gap-1" },
                              [
                                _c("BlTextBody1", {
                                  attrs: {
                                    text: "Drag and drop your files here or"
                                  }
                                }),
                                _vm._v(" "),
                                _c(
                                  "div",
                                  { on: { click: _vm.openUploadDoc } },
                                  [
                                    _c("BlTextBody1", {
                                      staticClass:
                                        "font-bold underline text-light-purple cursor-pointer",
                                      attrs: { text: "click to upload." }
                                    })
                                  ],
                                  1
                                )
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c(
                              "div",
                              [
                                _c("BlTextBody1", {
                                  attrs: {
                                    text: " Each file must not exceed 25 MB."
                                  }
                                })
                              ],
                              1
                            )
                          ]
                        )
                      : _c(
                          "div",
                          {
                            staticClass:
                              "relative min-h-120 grid grid-cols-4 gap-4",
                            on: {
                              dragenter: function($event) {
                                $event.preventDefault()
                                _vm.dropActive = true
                              },
                              dragover: function($event) {
                                $event.preventDefault()
                                _vm.dropActive = true
                              }
                            }
                          },
                          [
                            _c(
                              "div",
                              {
                                staticClass:
                                  "absolute top-0 left-0 z-10 h-full w-full min-h-120 text-center flex-col items-center justify-center gap-2 bg-slate-200 rounded border-2 border-dashed border-slate-500",
                                class: {
                                  hidden: !_vm.dropActive,
                                  flex: _vm.dropActive
                                },
                                on: {
                                  dragenter: function($event) {
                                    $event.preventDefault()
                                    _vm.dropActive = true
                                  },
                                  dragover: function($event) {
                                    $event.preventDefault()
                                    _vm.dropActive = true
                                  },
                                  dragleave: function($event) {
                                    $event.preventDefault()
                                    _vm.dropActive = false
                                  },
                                  drop: function($event) {
                                    $event.preventDefault()
                                    return _vm.onDropUpload($event)
                                  }
                                }
                              },
                              [
                                _c(
                                  "div",
                                  {
                                    staticClass:
                                      "h-10 w-10 flex items-center justify-center flex-shrink-0 bg-light-purple-100 rounded-full"
                                  },
                                  [
                                    _c("BlIcon", {
                                      staticClass: "h-6 w-6",
                                      style: { rotate: "180deg" },
                                      attrs: { icon: "download" }
                                    })
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                _c(
                                  "div",
                                  [
                                    _c("BlTextBody1", {
                                      attrs: {
                                        text: "Drag and drop your files here"
                                      }
                                    })
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                _c(
                                  "div",
                                  [
                                    _c("BlTextBody1", {
                                      attrs: {
                                        text:
                                          " Each file must not exceed 25 MB."
                                      }
                                    })
                                  ],
                                  1
                                )
                              ]
                            ),
                            _vm._v(" "),
                            _vm._l(_vm.clientDocuments, function(
                              document,
                              idx
                            ) {
                              return _c("ItemGrid", {
                                key: document.id,
                                attrs: {
                                  document: document,
                                  checked: !!_vm.selectedDocument.find(function(
                                    i
                                  ) {
                                    return i.id === document.id
                                  }),
                                  isLast: idx + 1 === _vm.clientDocuments.length
                                },
                                on: {
                                  "change-selected": function($event) {
                                    return _vm.onChangeSelected(document.id)
                                  },
                                  "after-commit": function($event) {
                                    return _vm.fetchDocuments(false)
                                  }
                                }
                              })
                            })
                          ],
                          2
                        )
                  ])
                : _vm._e(),
              _vm._v(" "),
              _vm.mode === "table"
                ? _c(
                    "div",
                    {
                      staticClass:
                        "overflow-x-auto scrollbar-lg border border-slate-400 rounded"
                    },
                    [
                      _c(
                        "div",
                        { staticClass: "flex", attrs: { id: "files-header" } },
                        [
                          _c(
                            "div",
                            { staticClass: "flex border-slate-400 rounded-tl" },
                            [
                              _c(
                                "div",
                                {
                                  staticClass:
                                    "w-14 px-4 py-4 flex-shrink-0 bg-slate-200 rounded-tl"
                                },
                                [
                                  _c("BlInputCheck", {
                                    attrs: {
                                      checked: _vm.checked,
                                      indeterminate: _vm.indeterminate
                                    },
                                    on: { changed: _vm.onChangeSelectedAll }
                                  })
                                ],
                                1
                              )
                            ]
                          ),
                          _vm._v(" "),
                          _c(
                            "div",
                            {
                              staticClass:
                                "w-112 flex-grow px-4 py-3 flex-shrink-0 bg-slate-200"
                            },
                            [
                              _c("BlTextSubtitle2", {
                                staticClass: "text-slate-700",
                                attrs: { text: "File name" }
                              })
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "div",
                            {
                              staticClass:
                                "w-50 px-4 py-3 flex-shrink-0 bg-slate-200"
                            },
                            [
                              _c("BlTextSubtitle2", {
                                staticClass: "text-slate-700",
                                attrs: { text: "Type" }
                              })
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "div",
                            {
                              staticClass:
                                "w-50 px-4 py-3 flex-shrink-0 bg-slate-200"
                            },
                            [
                              _c("BlTextSubtitle2", {
                                staticClass: "text-slate-700",
                                attrs: { text: "Uploaded on" }
                              })
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "div",
                            {
                              staticClass:
                                "w-50 px-4 py-3 flex-shrink-0 bg-slate-200"
                            },
                            [
                              _c("BlTextSubtitle2", {
                                staticClass: "text-slate-700",
                                attrs: { text: "Uploaded by" }
                              })
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _vm._m(0)
                        ]
                      ),
                      _vm._v(" "),
                      _vm.fetchLoading
                        ? _c(
                            "div",
                            {
                              staticClass:
                                "w-full h-120 grid place-items-center"
                            },
                            [_c("div", { staticClass: "blum-loader" })]
                          )
                        : !_vm.clientDocuments.length
                        ? _c("div", { staticClass: "h-120 py-4 px-4" }, [
                            _c(
                              "div",
                              {
                                staticClass:
                                  "h-full w-full text-center flex flex-col items-center justify-center gap-2 rounded border-2 border-dashed border-slate-500",
                                class: { "bg-slate-200": _vm.dropActive },
                                on: {
                                  dragenter: function($event) {
                                    $event.preventDefault()
                                    _vm.dropActive = true
                                  },
                                  dragover: function($event) {
                                    $event.preventDefault()
                                    _vm.dropActive = true
                                  },
                                  dragleave: function($event) {
                                    $event.preventDefault()
                                    _vm.dropActive = false
                                  },
                                  drop: function($event) {
                                    $event.preventDefault()
                                    return _vm.onDropUpload($event)
                                  }
                                }
                              },
                              [
                                _c(
                                  "div",
                                  {
                                    staticClass:
                                      "h-10 w-10 flex items-center justify-center flex-shrink-0 bg-light-purple-100 rounded-full"
                                  },
                                  [
                                    _c("BlIcon", {
                                      staticClass: "h-6 w-6",
                                      style: { rotate: "180deg" },
                                      attrs: { icon: "download" }
                                    })
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                _c(
                                  "div",
                                  { staticClass: "flex items-center gap-1" },
                                  [
                                    _c("BlTextBody1", {
                                      attrs: {
                                        text: "Drag and drop your files here or"
                                      }
                                    }),
                                    _vm._v(" "),
                                    _c(
                                      "div",
                                      { on: { click: _vm.openUploadDoc } },
                                      [
                                        _c("BlTextBody1", {
                                          staticClass:
                                            "font-bold underline text-light-purple cursor-pointer",
                                          attrs: { text: "click to upload." }
                                        })
                                      ],
                                      1
                                    )
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                _c(
                                  "div",
                                  [
                                    _c("BlTextBody1", {
                                      attrs: {
                                        text:
                                          " Each file must not exceed 25 MB."
                                      }
                                    })
                                  ],
                                  1
                                )
                              ]
                            )
                          ])
                        : _c(
                            "div",
                            {
                              staticClass: "relative min-h-120",
                              on: {
                                dragenter: function($event) {
                                  $event.preventDefault()
                                  _vm.dropActive = true
                                },
                                dragover: function($event) {
                                  $event.preventDefault()
                                  _vm.dropActive = true
                                }
                              }
                            },
                            [
                              _c(
                                "div",
                                {
                                  staticClass:
                                    "absolute top-0 left-0 z-10 h-full w-full px-4 py-4 bg-pure-white",
                                  class: {
                                    hidden: !_vm.dropActive,
                                    flex: _vm.dropActive
                                  }
                                },
                                [
                                  _c(
                                    "div",
                                    {
                                      staticClass:
                                        "h-full w-full text-center flex-col flex items-center justify-center gap-2 bg-slate-200 rounded border-2 border-dashed border-slate-500",
                                      on: {
                                        dragenter: function($event) {
                                          $event.preventDefault()
                                          _vm.dropActive = true
                                        },
                                        dragover: function($event) {
                                          $event.preventDefault()
                                          _vm.dropActive = true
                                        },
                                        dragleave: function($event) {
                                          $event.preventDefault()
                                          _vm.dropActive = false
                                        },
                                        drop: function($event) {
                                          $event.preventDefault()
                                          return _vm.onDropUpload($event)
                                        }
                                      }
                                    },
                                    [
                                      _c(
                                        "div",
                                        {
                                          staticClass:
                                            "h-10 w-10 flex items-center justify-center flex-shrink-0 bg-light-purple-100 rounded-full"
                                        },
                                        [
                                          _c("BlIcon", {
                                            staticClass: "h-6 w-6",
                                            style: { rotate: "180deg" },
                                            attrs: { icon: "download" }
                                          })
                                        ],
                                        1
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "div",
                                        [
                                          _c("BlTextBody1", {
                                            attrs: {
                                              text:
                                                "Drag and drop your files here"
                                            }
                                          })
                                        ],
                                        1
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "div",
                                        [
                                          _c("BlTextBody1", {
                                            attrs: {
                                              text:
                                                " Each file must not exceed 25 MB."
                                            }
                                          })
                                        ],
                                        1
                                      )
                                    ]
                                  )
                                ]
                              ),
                              _vm._v(" "),
                              _vm._l(_vm.clientDocuments, function(
                                document,
                                idx
                              ) {
                                return _c("ItemList", {
                                  key: document.id,
                                  attrs: {
                                    document: document,
                                    checked: !!_vm.selectedDocument.find(
                                      function(i) {
                                        return i.id === document.id
                                      }
                                    ),
                                    isLast:
                                      idx + 1 === _vm.clientDocuments.length
                                  },
                                  on: {
                                    "change-selected": function($event) {
                                      return _vm.onChangeSelected(document.id)
                                    },
                                    "after-commit": function($event) {
                                      return _vm.fetchDocuments(false)
                                    }
                                  }
                                })
                              })
                            ],
                            2
                          )
                    ]
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.totalClientDocuments > 25
                ? _c("BlInputPagination", {
                    attrs: {
                      page: _vm.page,
                      perPage: _vm.perPage,
                      total: _vm.totalClientDocuments
                    },
                    on: {
                      changed: _vm.changePage,
                      "changed-per-page": _vm.changePerPage
                    }
                  })
                : _vm._e()
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass:
                "fixed z-50 py-2 min-h-16 w-full max-w-200 px-6 flex items-center justify-between gap-2 bg-white rounded border border-slate-400 shadow-lg transition-all duration-500",
              class: [_vm.selectedDocument.length ? "bottom-16" : "-bottom-16"],
              style: {
                left: "50%",
                transform: "translateX(-50%)"
              }
            },
            [
              _c(
                "div",
                { staticClass: "flex items-center gap-2 truncate" },
                [
                  _c("BlInputButton", {
                    attrs: { type: "plain", icon: "close" },
                    on: {
                      clicked: function($event) {
                        _vm.selectedDocument = []
                      }
                    }
                  }),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "truncate" },
                    [
                      _c("BlTextSubtitle3", {
                        staticClass: "text-slate-800",
                        attrs: {
                          text:
                            _vm.selectedDocument.length + " file(s) selected"
                        }
                      })
                    ],
                    1
                  )
                ],
                1
              ),
              _vm._v(" "),
              _vm.selectedDocument.length
                ? _c(
                    "div",
                    { staticClass: "flex items-center gap-2" },
                    [
                      _c("BlInputButton", {
                        attrs: {
                          label: "Delete (" + _vm.selectedDocument.length + ")",
                          type: "outlined-error",
                          dense: "",
                          loading: _vm.deleteLoading
                        },
                        on: {
                          clicked: function($event) {
                            _vm.deleteOpened = true
                          }
                        }
                      }),
                      _vm._v(" "),
                      _c("BlInputButton", {
                        attrs: {
                          label:
                            "Download (" + _vm.selectedDocument.length + ")",
                          dense: "",
                          loading: _vm.downloadLoading
                        },
                        on: { clicked: _vm.onDownloadSelected }
                      })
                    ],
                    1
                  )
                : _vm._e()
            ]
          )
        ]
      ),
      _vm._v(" "),
      _vm.deleteOpened
        ? _c(
            "BlBackdrop",
            {
              attrs: {
                title: "Delete file",
                label: "Delete " + _vm.selectedDocument.length + " file(s)",
                type: "error",
                submitLoading: _vm.deleteLoading
              },
              on: {
                "backdrop-close": function($event) {
                  _vm.deleteOpened = false
                },
                "backdrop-action": _vm.onDeleteSelected
              }
            },
            [
              _c(
                "div",
                {
                  staticClass: "px-4 lg:px-8 overflow-y-auto",
                  style: { maxHeight: "calc(100vh - 14rem)" }
                },
                [
                  _c(
                    "div",
                    [
                      _c("BlTextBody2", {
                        attrs: {
                          text:
                            "You are about to delete the following file(s) from your client:"
                        }
                      })
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _vm._l(_vm.selectedDocument, function(document, idx) {
                    return _c(
                      "div",
                      {
                        key: idx,
                        staticClass: "flex items-center gap-2 px-2",
                        attrs: { title: document.filename }
                      },
                      [
                        _c("div", {
                          staticClass:
                            "rounded h-1 w-1 bg-slate-800 flex-shrink-0"
                        }),
                        _vm._v(" "),
                        _c("BlTextBody2", {
                          staticClass: "truncate",
                          attrs: { text: document.filename }
                        })
                      ],
                      1
                    )
                  }),
                  _vm._v(" "),
                  _c(
                    "div",
                    [
                      _c("BlTextBody2", {
                        attrs: {
                          text:
                            "Are you sure you want to proceed? This action is irreversible. "
                        }
                      })
                    ],
                    1
                  )
                ],
                2
              )
            ]
          )
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "div",
      { staticClass: "flex sticky right-0 z-10 bg-pure-white" },
      [
        _c("div", {
          staticClass: "w-60 px-4 py-3 rounded-tr flex-shrink-0 bg-slate-200"
        })
      ]
    )
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-0f7a817e", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0f7a817e","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/clients/ClientFile.vue
// module id = null
// module chunks = 